import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPublicAssessment = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19.119,
	height: 19.119,
	viewBox: "0 0 19.119 19.119",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "PublicAssessmentGroup_11877",
		"data-name": "Group 11877",
		transform: "translate(0.057 0.057)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "PublicAssessmentGroup_11878",
			"data-name": "Group 11878",
			transform: "translate(0.443 0.443)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "PublicAssessmentPath_25877",
					"data-name": "Path 25877",
					d: "M15.741,5.6a5.137,5.137,0,0,1-5.135,5.14A5.193,5.193,0,0,1,5.5,5.51a5.008,5.008,0,0,1,4.9-5q.11,0,.222,0A5.091,5.091,0,0,1,15.741,5.6Z",
					transform: "translate(-1.561 -0.5)",
					fill: "#dbd8f0",
					stroke: "#7284fa",
					strokeLinejoin: "round",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "PublicAssessmentPath_25878",
					"data-name": "Path 25878",
					d: "M11.181.506c-2.672,2.894-2.672,6.67,0,10.233",
					transform: "translate(-2.341 -0.501)",
					fill: "#dbd8f0",
					stroke: "#7284fa",
					strokeLinejoin: "round",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "PublicAssessmentPath_25879",
					"data-name": "Path 25879",
					d: "M12.285.506c2.672,2.894,2.672,6.669,0,10.231",
					transform: "translate(-3.001 -0.501)",
					fill: "#dbd8f0",
					stroke: "#7284fa",
					strokeLinejoin: "round",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("line", {
					id: "PublicAssessmentLine_582",
					"data-name": "Line 582",
					x2: 8.582,
					transform: "translate(4.785 7.878)",
					fill: "none",
					stroke: "#7284fa",
					strokeLinejoin: "round",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("line", {
					id: "PublicAssessmentLine_583",
					"data-name": "Line 583",
					x2: 8.7,
					transform: "translate(4.69 2.363)",
					fill: "none",
					stroke: "#7284fa",
					strokeLinejoin: "round",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("line", {
					id: "PublicAssessmentLine_584",
					"data-name": "Line 584",
					x2: 10.241,
					transform: "translate(3.939 5.121)",
					fill: "none",
					stroke: "#7284fa",
					strokeLinejoin: "round",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("circle", {
					id: "PublicAssessmentEllipse_587",
					"data-name": "Ellipse 587",
					cx: 1.969,
					cy: 1.969,
					r: 1.969,
					transform: "translate(1.182 11.041)",
					fill: "#dbd8f0",
					stroke: "#7284fa",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("circle", {
					id: "PublicAssessmentEllipse_588",
					"data-name": "Ellipse 588",
					cx: 1.969,
					cy: 1.969,
					r: 1.969,
					transform: "translate(7.09 11.041)",
					fill: "#dbd8f0",
					stroke: "#7284fa",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("circle", {
					id: "PublicAssessmentEllipse_589",
					"data-name": "Ellipse 589",
					cx: 1.969,
					cy: 1.969,
					r: 1.969,
					transform: "translate(12.999 11.041)",
					fill: "#dbd8f0",
					stroke: "#7284fa",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "PublicAssessmentPath_25880",
					"data-name": "Path 25880",
					d: "M15.468,19.507A3.145,3.145,0,0,0,12.514,21.6a3.134,3.134,0,0,0-5.908,0,3.148,3.148,0,0,0-2.954-2.092A3.257,3.257,0,0,0,.5,22.653H18.619A3.257,3.257,0,0,0,15.468,19.507Z",
					transform: "translate(-0.5 -4.533)",
					fill: "#dbd8f0",
					stroke: "#7284fa",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1
				})
			]
		})
	})
});
export default SvgPublicAssessment;
